var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"currency-select-wrap"},[_c('select-2',{staticClass:"w-full currency-select-field",attrs:{"name":_vm.name,"placeholder":_vm.placeholder,"value":_vm.value,"options":_vm.selectOptions,"autocomplete":"","ssr":false,"clearable":false},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }